// Shared tee colour helper for the course wizard.
const TEE_COLOR_OVERRIDES = {
  white: '#ffffff', yellow: '#f5c542', red: '#e74c3c', blue: '#3498db',
  black: '#2c3e50', green: '#27ae60', gold: '#f5a623', orange: '#e67e22',
  burgundy: '#800020', maroon: '#800000', purple: '#8e44ad', silver: '#bdc3c7',
  emerald: '#50c878', bronze: '#cd7f32', copper: '#b87333',
};

export const getTeeColor = (name) => {
  const key = name?.toLowerCase().trim();
  if (!key) return '#94a3b8';
  if (TEE_COLOR_OVERRIDES[key]) return TEE_COLOR_OVERRIDES[key];
  const embedded = Object.keys(TEE_COLOR_OVERRIDES).find(c => key.includes(c));
  return embedded ? TEE_COLOR_OVERRIDES[embedded] : '#94a3b8';
};

export default getTeeColor;
